import { useEffect, useState } from "react";
import { api, formatApiError } from "@/context/AuthContext";

export default function AdminPracticeHoursConfig() {
  const [cfg, setCfg] = useState(null);
  const [history, setHistory] = useState([]);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/practice-hours/config").then((res) => setCfg(res.data)).catch((err) => setError(formatApiError(err)));
    api
      .get("/practice-hours/admin/config/history")
      .then((res) => setHistory(res.data?.history || []))
      .catch(() => setHistory([]));
  }, []);

  async function save(e) {
    e.preventDefault();
    if (!cfg) return;
    setBusy(true);
    setError("");
    try {
      const res = await api.put("/practice-hours/admin/config", {
        target_hours: Number(cfg.target_hours),
        label: cfg.label,
        eligible_entry_types: cfg.eligible_entry_types,
        effective_from: cfg.effective_from,
        official_requirement_note: cfg.official_requirement_note || "",
      });
      setCfg(res.data.config);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  }

  if (!cfg) return null;

  return (
    <section className="card space-y-3 mt-6" data-testid="admin-practice-hours-config">
      <h2 className="text-lg font-semibold">GDI practice hours target</h2>
      <p className="text-sm text-muted-foreground">
        Configure the practice target label and hours. Changing the target does not alter past entries or completion records.
      </p>
      <form className="grid gap-3 max-w-lg" onSubmit={save}>
        <label className="text-sm">
          Label
          <input className="input mt-1" value={cfg.label || ""} onChange={(e) => setCfg({ ...cfg, label: e.target.value })} />
        </label>
        <label className="text-sm">
          Target hours
          <input
            className="input mt-1 w-32"
            type="number"
            min={1}
            value={cfg.target_hours}
            onChange={(e) => setCfg({ ...cfg, target_hours: e.target.value })}
          />
        </label>
        <label className="text-sm">
          Effective from (date)
          <input
            className="input mt-1"
            value={cfg.effective_from || ""}
            onChange={(e) => setCfg({ ...cfg, effective_from: e.target.value })}
          />
        </label>
        <label className="text-sm">
          Official requirement note (optional, versioned reference)
          <textarea
            className="input mt-1 min-h-[80px]"
            value={cfg.official_requirement_note || ""}
            onChange={(e) => setCfg({ ...cfg, official_requirement_note: e.target.value })}
          />
        </label>
        <button type="submit" className="btn-primary w-fit" disabled={busy}>Save practice target</button>
      </form>
      {history.length > 0 && (
        <details className="text-sm">
          <summary>Target change history ({history.length})</summary>
          <ul className="list-disc ml-4 mt-2 space-y-1 text-xs text-muted-foreground">
            {history.slice(0, 10).map((h) => (
              <li key={h.id}>
                {h.superseded_at}: {h.previous?.target_hours}h → {h.next?.target_hours}h (effective {h.next?.effective_from})
              </li>
            ))}
          </ul>
        </details>
      )}
      {error && <p className="text-destructive text-sm">{error}</p>}
    </section>
  );
}
